export interface IApiGallery {
  GalleryID: number;
  Name: string;
  IsPublic: boolean;
  ImageCount: number;
}

export interface IApiPhoto {
  PhotoID: number;
  Gallery: IApiGallery;
  ThumbUrl: string;
  FullUrl: string;
  ApprovalStatus: string;
  Width: number;
  Height: number;
  IsUserImage: boolean;
  Classification: any;
  MainPhoto: boolean;
  PrivateGalleryOnly: boolean;
}

export interface IGalleryModel {
  galleryId: number | null;
  name: string;
  isPublic: boolean;
  imageCount: number;
  icon: string;
}

export interface IPhotoModel {
  photoId: number | null;
  gallery: IGalleryModel | null;
  thumbUrl: string | null;
  fullUrl: string | null;
  approvalStatus: string;
  mainPhoto: boolean;
  width: number | null;
  height: number | null;
  isUserImage: boolean;
  classification: any | null;
  privateGalleryOnly: boolean;
}

export default class editProfile {
  static generateGalleriesIcon(galleriesName: string): string {
    if (galleriesName.includes('Public')) {
      return 'icPublicAlbum';
    }
    if (galleriesName.includes('Private')) {
      return 'icPrivateAlbum';
    }
    return '';
  }

  static mappingObjectGallery(_obj: IApiGallery): IGalleryModel {
    const obj: IGalleryModel = {
      galleryId: null,
      name: '',
      isPublic: false,
      imageCount: 0,
      icon: '',
    };
    obj.galleryId = _obj.GalleryID;
    obj.name = '';
    if (_obj.Name) {
      obj.name = _obj.Name === 'Public' ? 'Public Album' : _obj.Name;
    }

    // Explicit check for boolean or null/undefined if incoming data is messy,
    // but based on type it should be boolean.
    obj.isPublic = _obj.IsPublic ? _obj.IsPublic : false;
    obj.imageCount = _obj.ImageCount;
    obj.icon = editProfile.generateGalleriesIcon(_obj.Name);
    return obj;
  }

  static mappingObjectPhoto(_obj: IApiPhoto | null): IPhotoModel {
    const obj: IPhotoModel = {
      photoId: null,
      gallery: {
        galleryId: null,
        name: '',
        isPublic: false,
        imageCount: 0,
        icon: '',
      },
      thumbUrl: '',
      fullUrl: '',
      approvalStatus: '',
      mainPhoto: false,
      width: null,
      height: null,
      isUserImage: false,
      classification: null,
      privateGalleryOnly: false,
    };
    obj.photoId = _obj ? _obj.PhotoID : null;

    // Check if Gallery exists on _obj before mapping
    obj.gallery = _obj && _obj.Gallery ? editProfile.mappingObjectGallery(_obj.Gallery) : null;

    obj.thumbUrl = _obj && _obj.ThumbUrl ? _obj.ThumbUrl : null;
    obj.fullUrl = _obj && _obj.FullUrl ? _obj.FullUrl : null;
    obj.approvalStatus = _obj ? _obj.ApprovalStatus : '';
    obj.width = _obj && _obj.Width ? _obj.Width : null;
    obj.height = _obj && _obj.Height ? _obj.Height : null;
    obj.isUserImage = _obj && _obj.IsUserImage ? _obj.IsUserImage : false;
    obj.classification = _obj ? _obj.Classification : null;
    obj.mainPhoto = _obj ? _obj.MainPhoto : false;
    obj.privateGalleryOnly = _obj && _obj.PrivateGalleryOnly ? _obj.PrivateGalleryOnly : false;
    return obj;
  }

  static mappingObjectsPhoto(_data: IApiPhoto[]): IPhotoModel[] {
    const data: IPhotoModel[] = [];
    _data.forEach(_obj => {
      const obj = editProfile.mappingObjectPhoto(_obj);
      data.push(obj);
    });
    return data;
  }

  static mappingObjectsGalleries(_data: IApiGallery[]): IGalleryModel[] {
    const data: IGalleryModel[] = [];
    _data.forEach(_obj => {
      const obj = editProfile.mappingObjectGallery(_obj);
      data.push(obj);
    });
    return data;
  }
}
